import Typography from '@mui/material/Typography';
import {formatCopy} from 'utils/typography';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {LinkPopover} from '@vedmarket/ui-kit';
import HelpPanel from '../../help-panel';
import Chat from '../../../chat';

const AIAssistant = ({ handleApplyCode, isActive }: ChatProps) => {
  const { t } = useTranslation();

  const [ expanded, setExpanded ] = useState(true);

  return <div className='ai-assistant'>
    <HelpPanel
      title={t('calc__text__packaging__AIAssistant')}
      expanded={expanded}
      onChange={setExpanded}
      headerHelp={<LinkPopover
        linkText={t('calc__help__aiAssistantLink')}
        text={formatCopy(t('calc__help__aiAssistant'))}
      />}
    >
      <Chat handleApplyCode={handleApplyCode} isActive={isActive && expanded} />
    </HelpPanel>
  </div>;
};

export default AIAssistant;
